import { safeFocusInit as initializeSafeFocus } from '@sparkbox/safe-focus';
import { setBuildVersion } from './sitewide/buildVersion';
import { configureButtonsForToggling } from './utilities/accordion';
import { configureSecondaryMenu } from './sitewide/header';
import { toggleMenu } from './utilities/toggleMenuHelpers';
import { registerToggles } from './utilities/toggle';
import { initializeMainMenu } from './sitewide/mainMenu';
import { initializeLiveChat } from './sitewide/liveChat';
import { initializeModals } from './utilities/modal';
import { renderStoreDetails } from './sitewide/storeDetails';
import { initializeSideNavAccordions } from './sitewide/sideNav';

(({
  featureFlags,
  redirect,
  hasStoreDetails,
} = {}) => {
  if (redirect?.target) {
    window.parent.location = redirect.target;

    return;
  }

  setBuildVersion();
  initializeSafeFocus();

  if (featureFlags?.full_page) {
    const hamburger = document.querySelector('#header-menu-button-wrapper');
    hamburger.classList.add('js-hamburger-trigger');

    configureButtonsForToggling(
      document.querySelectorAll('.cmp-header__menu-button, .cmp-secondary-nav__button'),
      document.querySelectorAll('.cmp-header__content, .cmp-secondary-nav__list-container'),
    );

    // Fixes the page when menu is open
    toggleMenu(
      document.querySelectorAll('.cmp-header__menu-button, .cmp-secondary-nav__button'),
      document.querySelector('.cmp-fixed-wrapper'),
    );

    configureSecondaryMenu();
    initializeMainMenu();
    if (featureFlags?.live_chat) initializeLiveChat();

    window.addEventListener('storeDetails', (event) => renderStoreDetails(event.detail));
  }

  if (featureFlags?.core_features && !hasStoreDetails) {
    import(
      /* webpackChunkName: "storeSelector" */
      './sitewide/storeSelector'
    ).then(({ initializeStoreSelector }) => {
      initializeStoreSelector();
    });
  }

  registerToggles();
  initializeModals(document.querySelectorAll('.modal-wrapper'));
  initializeSideNavAccordions();
})(window.drupalSettings);
